// extracted by mini-css-extract-plugin
export default {"slideTextWrapper":"_8cq6rEUX","showAllLabels":"_30bqPsH6"};